/**
 * Test if a string (or number) value is numeric.
 *
 * @param {Number|string} v Value to test.
 * @returns {boolean}
 */
export default function isNumeric(v: number | string): boolean {
  return /^-?\d*.?\d*$/.test(String(v));
}
